import { render, staticRenderFns } from "./ButtonEditControl.vue?vue&type=template&id=1b51a7ce&scoped=true"
import script from "./ButtonEditControl.vue?vue&type=script&lang=js"
export * from "./ButtonEditControl.vue?vue&type=script&lang=js"
import style0 from "./ButtonEditControl.vue?vue&type=style&index=0&id=1b51a7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b51a7ce",
  null
  
)

export default component.exports